var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4672 0H0.532787C0.238689 0 0 0.242149 0 0.540511C0 0.838874 0.238689 1.08102 0.532787 1.08102H12.4672C12.7613 1.08102 13 0.838874 13 0.540511C13 0.242149 12.7613 0 12.4672 0ZM9.90984 3.4597H3.09016C2.79607 3.4597 2.55738 3.70185 2.55738 4.00022C2.55738 4.29858 2.79607 4.54073 3.09016 4.54073H9.90984C10.2039 4.54073 10.4426 4.29858 10.4426 4.00022C10.4426 3.70185 10.2039 3.4597 9.90984 3.4597ZM7.77869 6.91898H5.19872C4.90462 6.91898 4.66593 7.16113 4.66593 7.45949C4.66593 7.75785 4.90462 8 5.19872 8H7.77869C8.07279 8 8.31148 7.75785 8.31148 7.45949C8.31148 7.16113 8.07279 6.91898 7.77869 6.91898Z",
    fill: "#1E1E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.d3409a8acfcb7f11a59bbbd0ad83098b.svg";
export { ForwardRef as ReactComponent };